<template>
  <div class="text-center flex flex-col h-screen items-center justify-center">
    <h1
      class="text-2xl font-bold"
      :class="{
        'text-primary-0': isKids || isPets,
        'text-guardian-secondary-0': isGuardian
      }"
    >
      404
    </h1>
    <p>{{ $t('404') }}</p>
  </div>
</template>

<script setup>
import { isKids, isGuardian, isPets } from '@/comp/AppType'
</script>
